import {
  Component,
  OnInit,
  AfterViewInit,
  Input,
  ViewChild,
  ElementRef,
  NgZone,
} from "@angular/core";
import { Router, ActivatedRoute, Params } from "@angular/router";
import { AdminService } from "../../service/admin.service";
import { UtilService } from "../../service/util.service";
import * as constants from "../../app.constants";
import { ModalComponent } from "ng2-bs3-modal/ng2-bs3-modal";
import { NotificationsService } from "angular2-notifications";
import { PagerService } from "../../pipe/pagination";
import { Ticket } from "../../model/ticket";
import { User } from "../../model/user";
import { Category } from "../../model/category";
import { Currency } from "../../model/currency";
import { Location } from "../../model/location";
import { Price } from "../../model/price";
import { ProfileImage } from "../../model/profile_image";
import { ErrorResponse } from "../../model/error-response";
import { FormControl } from "@angular/forms";
import { MapsAPILoader } from "@agm/core";
import { debug } from "util";

declare let $: any;

@Component({
  selector: "tickets",
  template: require('./ticket.component.html'),
  styles: [require('./ticket.component.css'), require('./table-scroll.css')],
})
export class TicketComponent implements OnInit, AfterViewInit {
  public cloneModel: any = {};
  public editTicketModel: any = {};
  public clonableTicket: any = {};
  public minEventDate: Date;
  public curDate: Date = new Date();
  public maxEventDate: Date;
  public eventDays: boolean = false;
  public endDate: any;
  ticketSourceValue = 0;

  public tickets: Ticket[];
  public ticketType: number; // Type of ticket (All | Inactive | Fake)
  public page: number; // Current Page
  public pageSize: number; // Number of items per page
  public count: number; // Number of items in result
  public pager: any = {};
  public message: string = constants.messages.loading;
  public errorMsg: string;
  public pageSizes: number[];
  public showLoader: boolean;
  imageUpload_Id: string = "";
  editImage: any = "";
  disabled: boolean = false;
  categoryName = "";
  ticketId: string = "";
  public ticketTypes = {
    1: "All Tickets",
    2: "Active Tickets",
    3: "Inactive Tickets",
    4: "Fake Tickets",
    5: "Tickets Created By Admin",
    6: "Fake Ticket Requests",
  };

  // Fields related to update ticket
  @ViewChild("updateTicketModal") public updateTicketModal: ModalComponent;
  @ViewChild("approveRejectModal") public approveRejectModal: ModalComponent;
  @ViewChild("updateTicketModalAdmin")
  public updateTicketModalAdmin: ModalComponent;
  @ViewChild("cloneTicketModal") public cloneTicketModal: ModalComponent;
  @ViewChild("cancelTicketModal") public cancelTicketModal: ModalComponent;
  @ViewChild("deleteTicketModal") public deleteTicketModal: ModalComponent;
  @ViewChild("confirmViewDuplicateTicketModal")
  public confirmViewDuplicateTicketModal: ModalComponent;
  @ViewChild("confirmEditCloseModal")
  public confirmEditCloseModal: ModalComponent;
  @ViewChild("form") editForm: any;
  public ticket: Ticket;
  public formErrors: any;
  public editErrors: any = {};
  public categories: Category[] = constants.categories;
  public ticketStatus: any = constants.ticketStatus;
  public ticketDetails: Ticket;
  cntErrorMsg: any;
  //map variable
  public latitude: number;
  public longitude: number;
  public searchControl: FormControl;
  public zoom: number;
  public alwaysTrue: boolean = true;
  @ViewChild("search")
  public searchElementRef: ElementRef;
  @ViewChild("searchFilter")
  public searchFilterElementRef: ElementRef;
  // public searchElementRef: any
  public disableCancel: boolean = false;
  public disableDelete: boolean = false;
  public listOptionsAll = [
    { id: 0, name: "All" },
    { id: 1, name: "Active Tickets" },
    { id: 2, name: "Sold Tickets" },
    { id: 3, name: "Cancelled Tickets" },
    { id: 4, name: "Expired Tickets" },
  ];

  public listOptionsInactive = [
    { id: 0, name: "All" },
    { id: 1, name: "Sold Tickets" },
    { id: 2, name: "Cancelled Tickets" },
    { id: 3, name: "Expired Tickets" },
  ];
  public filterValueAll: any;
  public filterValueInactive: any;

  public location = "";
  public category = "";
  public title = "";
  public clearFilter = false;
  public searchRequest: string = "";
  public dateSort: number;
  public priceSort: number;
  public imageError = false;
  public ticketSource = 0;

  constructor(
    private router: Router,
    private mapsAPILoader: MapsAPILoader,
    private route: ActivatedRoute,
    public _notificationsService: NotificationsService,
    private adminService: AdminService,
    private ngZone: NgZone,
    private pagerService: PagerService
  ) {
    //console.debug('constructor init fields');
    // Initialize fields
    this.page = 1;
    this.pageSize = 10;
    this.pageSizes = [10, 20, 50, 100];
    this.formErrors = {};
    this.searchControl = new FormControl();
    this.minEventDate = new Date();
    this.maxEventDate = new Date();
    this.maxEventDate.setFullYear(this.maxEventDate.getFullYear() + 1);
    this.filterValueAll = 0;
    this.filterValueInactive = 0;
    this.priceSort = 0;
    this.dateSort = 0;
  }

  public openDetailsModal(details) {
    this.ticketDetails = details;
  }
  selectChangeAll(event) {
    //In my case $event come with a id value
    this.filterValueAll = event;
    this.getTickets(1, this.pageSize);
  }
  selectChangeInactive(event) {
    //In my case $event come with a id value
    this.filterValueInactive = event;
    this.getTickets(1, this.pageSize);
  }

  onPriceClick() {
    if (this.priceSort === 0) {
      this.dateSort = 0;
      this.priceSort = 1;
      this.getTickets(this.page, this.pageSize);
    } else if (this.priceSort === 1) {
      this.dateSort = 0;
      this.priceSort = 2;
      this.getTickets(this.page, this.pageSize);
    } else if (this.priceSort === 2) {
      this.dateSort = 0;
      this.priceSort = 1;
      console.log(this.priceSort);
      this.getTickets(this.page, this.pageSize);
    }
  }

  onDateClick() {
    if (this.dateSort === 0) {
      this.priceSort = 0;
      this.dateSort = 1;
      this.getTickets(this.page, this.pageSize);
    } else if (this.dateSort === 1) {
      this.priceSort = 0;
      this.dateSort = 2;
      this.getTickets(this.page, this.pageSize);
    } else if (this.dateSort === 2) {
      this.priceSort = 0;
      this.dateSort = 1;
      console.log(this.dateSort);
      this.getTickets(this.page, this.pageSize);
    }
  }

  public loadPlaces(): void {
    // load Places Autocomplete
    this.mapsAPILoader.load().then(() => {
      let autocomplete = new google.maps.places.Autocomplete(
        this.searchElementRef.nativeElement,
        {
          // types: ['address']
        }
      );
      autocomplete.addListener("place_changed", () => {
        this.ngZone.run(() => {
          // get the place result
          let place: google.maps.places.PlaceResult = autocomplete.getPlace();

          // verify result
          if (place.geometry === undefined || place.geometry === null) {
            // this.ticket.location = null;
            return;
          }

          //console.log('place');
          // console.debug(place);

          let location = new Location();
          // location.name = place['name'];
          // location.address = place['formatted_address'];
          location.name = this.searchElementRef.nativeElement.value;
          location.address = this.searchElementRef.nativeElement.value;
          location.lat = place.geometry.location.lat();
          location.long = place.geometry.location.lng();
          location.coords = {
            latitude: location.lat,
            longitude: location.long,
          };
          this.editTicketModel.location = location;

          // set latitude, longitude and zoom
          this.latitude = location.lat;
          this.longitude = location.long;
          this.zoom = constants.mapOptions.searchZoom;
        });
      });
    });
  }

  public loadPlacesFilter(): void {
    // load Places Autocomplete
    this.mapsAPILoader.load().then(() => {
      let autocomplete = new google.maps.places.Autocomplete(
        this.searchFilterElementRef.nativeElement,
        {
          // types: ['address']
        }
      );
      autocomplete.addListener("place_changed", () => {
        this.ngZone.run(() => {
          // get the place result
          let place: google.maps.places.PlaceResult = autocomplete.getPlace();

          // verify result
          if (place.geometry === undefined || place.geometry === null) {
            // this.ticket.location = null;
            return;
          }

          //console.log('place');
          // console.debug(place);

          let location = new Location();
          // location.name = place['name'];
          // location.address = place['formatted_address'];
          location.name = this.searchFilterElementRef.nativeElement.value;
          location.address = this.searchFilterElementRef.nativeElement.value;
          location.lat = place.geometry.location.lat();
          location.long = place.geometry.location.lng();
          location.coords = {
            latitude: location.lat,
            longitude: location.long,
          };

          // set latitude, longitude and zoom
          this.latitude = location.lat;
          this.longitude = location.long;
          this.zoom = constants.mapOptions.searchZoom;
        });
      });
    });
  }

  public ngOnInit(): void {
    // console.debug('TicketComponent.ngOnInit() called');
    // Subscribing to query params, so that any change in that will invoke this function.
    this.route.queryParams.forEach((queryParams: Params) => {
      //console.log('TicketComponent.ngOnInit() queryParams');
      //console.log(queryParams);
      this.ticketType = UtilService.validateDigit(queryParams["tkttype"])
        ? +queryParams["tkttype"]
        : 2;
      // When admin(this.ticketType === 5) tickets clicked from dashboard need to set Ticket Source select as `User generated tickets`(this.ticketSourceValue = 4)
      if (this.ticketType === 5) {
        this.onTicketSourceChange(4);
      }

      if (
        UtilService.validateDigit(queryParams["page"]) &&
        UtilService.validateDigit(queryParams["size"])
      ) {
        this.page = +queryParams["page"];
        this.pageSize = +queryParams["size"];
      } else {
        this.page = 1;
        this.pageSize = 10;
      }
      this.searchRequest = "";
      // Show tickets with default page number and size
      this.getTickets();
      this.ticketId = queryParams["tktid"];
      if (this.ticketId) {
        this.getTicketDetail(this.ticketId);
      }
    });
    // console.debug('Exiting TicketComponent.ngOnInit()');
  }

  public ngAfterViewInit(): void {
    // After view init
    this.loadPlaces();
    this.loadPlacesFilter();
  }

  public onDateChanged(event, type) {
    //console.debug(`onDateChanged type=${type}`);
    //console.debug(`Local=${event.toLocaleString()}, UTC=${event.toISOString()}`);
    event.setSeconds(0);
    event.setMilliseconds(0);
  }

  public getTickets(selectedPage?: number, newPazeSize?: number): void {
    //console.debug('Get list of tickets');
    selectedPage = selectedPage ? selectedPage : this.page;
    newPazeSize = newPazeSize ? newPazeSize : this.pageSize;
    let searchRequest = "";
    if (this.searchRequest.length !== 0) {
      searchRequest = this.searchRequest;
    }
    let pageOptions = {
      page: selectedPage,
      page_size: newPazeSize,
    };
    let url;
    switch (this.ticketType) {
      case 1:
        url =
          constants.URLs.allTickets +
          "?" +
          $.param(pageOptions) +
          "&ticket_filter=" +
          this.filterValueAll +
          "&sort_date=" +
          this.dateSort +
          "&sort_price=" +
          this.priceSort +
          searchRequest;
        break;
      case 2:
        pageOptions["active"] = true;
        url =
          constants.URLs.activeTickets +
          "?" +
          $.param(pageOptions) +
          "&sort_date=" +
          this.dateSort +
          "&sort_price=" +
          this.priceSort +
          searchRequest;
        break;
      case 3:
        url =
          constants.URLs.inactiveTickets +
          "?" +
          $.param(pageOptions) +
          "&ticket_filter=" +
          this.filterValueInactive +
          "&sort_date=" +
          this.dateSort +
          "&sort_price=" +
          this.priceSort +
          searchRequest;
        break;
      case 4:
        url =
          constants.URLs.fakeTickets +
          "?" +
          $.param(pageOptions) +
          "&sort_date=" +
          this.dateSort +
          "&sort_price=" +
          this.priceSort +
          searchRequest;
        break;
      case 5:
        pageOptions["status"] = 1;
        url =
          constants.URLs.myTickets.replace(
            "{user_id}",
            localStorage.getItem("userId")
          ) +
          "?" +
          $.param(pageOptions) +
          "&sort_date=" +
          this.dateSort +
          "&sort_price=" +
          this.priceSort +
          searchRequest;
        break;
      case 6:
        url =
          constants.URLs.fakeTicketRequests +
          "?" +
          $.param(pageOptions) +
          "&sort_date=" +
          this.dateSort +
          "&sort_price=" +
          this.priceSort +
          searchRequest;
        break;
      default:
        this.ticketType = 2;
        pageOptions["active"] = true;
        url =
          constants.URLs.activeTickets +
          "?" +
          $.param(pageOptions) +
          "&sort_date=" +
          this.dateSort +
          "&sort_price=" +
          this.priceSort +
          searchRequest;
    }

    if (this.ticketSource != 0) {
      url = url + "&ticket_source=" + this.ticketSource;
    }

    this.showLoader = true;
    this.adminService
      .getCall(url, true)
      .then((res) => {
        //console.log('getTickets res');
        //console.log(res);
        this.showLoader = false;
        this.count = res.count;
        this.tickets = res.results;
        this.message = null;
        this.page = selectedPage;
        this.pageSize = newPazeSize;
        this.pager = this.pagerService.getPager(
          this.count,
          selectedPage,
          newPazeSize
        );
      })
      .catch((error: any) => {
        //console.error('TicketComponent- an error occurred', error);
        this.showLoader = false;
        try {
          this.errorMsg =
            error.json().error_msg || constants.messages.serverError;
        } catch (e) {
          this.errorMsg = error.message
            ? error.message
            : constants.messages.serverError;
        }

        if (this.errorMsg == "Invalid page.") {
          let totalPages = Math.ceil(this.count / newPazeSize);
          this.pager = this.pagerService.getPager(
            this.count,
            totalPages,
            newPazeSize
          );
          this.getTickets(totalPages, newPazeSize);
        } else {
          this.adminService.showErrorToast(this.errorMsg);
        }
      });
  }

  // apply filters button.......
  public ApplyFilters() {
    if (this.searchFilterElementRef.nativeElement.value) {
      this.location = this.searchFilterElementRef.nativeElement.value;
    }

    this.clearFilter = !(
      this.location.length === 0 &&
      this.category.length === 0 &&
      this.title.length === 0
    );
    this.searchRequest = "";
    if (this.location.length !== 0) {
      this.searchRequest =
        this.searchRequest + "&ticket_location=" + this.location;
    }
    if (this.category.length !== 0) {
      this.searchRequest =
        this.searchRequest + "&ticket_category=" + this.category;
    }
    if (this.title.length !== 0) {
      this.searchRequest = this.searchRequest + "&ticket_title=" + this.title;
    }
    this.getTickets(1);
  }

  // clear filters button ..............
  public ClearFilters() {
    this.clearFilter = false;
    this.searchRequest = "";
    this.location = "";
    this.title = "";
    this.category = "";
    this.getTickets(1);
  }

  public goToPage(selectedPage: number) {
    if (this.pager.currentPage === selectedPage) {
      return;
    }
    if (selectedPage < 1 || selectedPage > this.pager.totalPages) {
      return;
    }
    // Show tickets with selected page number and existing page size
    this.getTickets(selectedPage);
  }

  public onPageSizeChange(newPazeSize: number): void {
    //console.log(newPazeSize);
    this.getTickets(this.page, newPazeSize);
  }

  public markTicketFake(ticket: Ticket): void {
    //console.debug(`markTicketFake ${ticket.ticket_id} is_flagged=${ticket.is_flagged}`);
    if (!ticket.is_flagged) {
      //console.info('Ticket once flagged can\'t be reverted.');
      return;
    }
    let url = constants.URLs.markTicketFake.replace(
      "{ticket_id}",
      ticket.ticket_id
    );
    //console.debug(url);
    this.adminService
      .markTicketFake(url, {}, true)
      .then((res) => {
        //console.log('markTicketFake res');
        //console.log(res);
        if (res.status === 200) {
          this.adminService.showSuccessToast(
            constants.messages.userStatusUpdate
          );
          this.getTickets();
        }
      })
      .catch((error: any) => {
        ticket.is_flagged = !ticket.is_flagged; // Revert the change
        try {
          this.errorMsg =
            error.json().error_msg || constants.messages.serverError;
          //console.debug('TicketComponent- an error occurred', error);
        } catch (e) {
          this.errorMsg = error.message
            ? error.message
            : constants.messages.serverError;
          //console.error('TicketComponent- an error occurred', error);
        }
        this.adminService.showErrorToast(this.errorMsg);
      });
  }

  public cancelTicket(ticket: Ticket): void {
    //console.debug(`cancelTicket ${ticket.ticket_id} isCancelled=${ticket.isCancelled}`);
    if (!ticket.isCancelled && ticket.hasOwnProperty("isCancelled")) {
      //console.info('Ticket once cancelled can\'t be reverted.');
      return;
    }
    let url = constants.URLs.cancelTicket.replace(
      "{user_id}",
      localStorage.getItem("userId")
    );
    url = url.replace("{ticket_id}", ticket.ticket_id);

    //console.debug(url);
    this.disableCancel = true;
    this.adminService
      .cancelTicket(url, true)
      .then((res) => {
        //console.log('cancelTicket res');
        //console.log(res);
        this.closeCancelTicketModal();
        if (res.status === "success") {
          this.adminService.showSuccessToast(constants.messages.cancelTicket);
          this.getTickets();
        }
        this.disableCancel = false;
      })
      .catch((error: any) => {
        ticket.isCancelled = !ticket.isCancelled; // Revert the change
        try {
          this.errorMsg =
            error.json().error_msg || constants.messages.serverError;
          //console.debug('TicketComponent- an error occurred', error);
        } catch (e) {
          this.errorMsg = error.message
            ? error.message
            : constants.messages.serverError;
          //console.error('TicketComponent- an error occurred', error);
        }
        this.disableCancel = false;
        this.closeCancelTicketModal();
        this.adminService.showErrorToast(this.errorMsg);
      });
  }

  public openUpdateTicketModal(ticketId: string = null): void {
    // alert('add or update');
    this.ticket = this.tickets.filter((tkt) => tkt.ticket_id === ticketId)[0];
    this.ticket = JSON.parse(JSON.stringify(this.ticket));
    this.ticket.category_id = this.ticket.category.category_id;
    this.errorMsg = null;
    this.formErrors = {};
    this.updateTicketModal.open();
  }

  public openCancelTicketModal(ticketId: string = null): void {
    this.ticket = this.tickets.filter((tkt) => tkt.ticket_id === ticketId)[0];
    this.errorMsg = null;
    this.formErrors = {};
    this.cancelTicketModal.open();
  }

  public openDeleteTicketModal(ticketId: string = null): void {
    this.ticket = this.tickets.filter((tkt) => tkt.ticket_id === ticketId)[0];
    this.errorMsg = null;
    this.formErrors = {};
    this.deleteTicketModal.open();
  }

  public closeUpdateTicketModal(): void {
    this.updateTicketModal.close();
    this.ticket = null;
  }

  public closeDeleteTicketModal(): void {
    this.deleteTicketModal.close();
    this.ticket = null;
  }

  public closeViewDuplicateTicketModal(): void {
    this.confirmViewDuplicateTicketModal.close();
    this.ticketId = "";
  }

  public closeCancelTicketModal(): void {
    this.cancelTicketModal.close();
    this.ticket = null;
  }

  public closeEditModal() {
    this.updateTicketModalAdmin.close();
  }

  public openEditModal(ticket) {
    //debugger
    this.deleteUpdateTicketErrors();
    this.eventDays = ticket.end_date ? true : false;
    this.editTicketModel["ticket_id"] = ticket.ticket_id;
    this.editTicketModel["event_url"] = ticket.event_url;
    this.editTicketModel["company_name"] = ticket.company_name;
    this.editTicketModel["price_per_ticket"] = ticket.price.per_ticket || 0;
    this.editTicketModel["description"] = ticket.description;
    this.editTicketModel["category"] = ticket.category.category_id || 1;
    this.editTicketModel["event_date"] = ticket.event_date;
    this.editTicketModel["number_of_tickets"] = ticket.number_of_tickets;
    this.editTicketModel["unlimited_tickets"] =
      ticket.number_of_tickets === null;
    this.editTicketModel["location"] = ticket.location;
    this.editTicketModel["is_free"] = ticket.price.per_ticket === 0;
    this.editTicketModel["is_recurring"] = ticket.is_recurrence_ticket
      ? "Yes"
      : "No";
    this.editTicketModel["image"] = null;
    this.editTicketModel["eventMoreThanOneDay"] = this.eventDays;
    this.editTicketModel["pick_up_address"] = ticket.pick_up_address;
    this.editTicketModel["title"] = ticket.title;
    this.editTicketModel["purchase_ticket_count"] = ticket.purchase_ticket_count
      ? ticket.purchase_ticket_count
      : 0;
    this.editTicketModel["creator"] =
      ticket.seller && ticket.seller.name ? ticket.seller.name : "";
    this.editTicketModel["status"] = ticket.status;
    this.categoryName = ticket.category.name;
    if (this.eventDays) {
      this.editTicketModel["end_date"] = ticket.end_date
        ? ticket.end_date
        : null;
      this.endDate = ticket.end_date;
    } else {
      this.editTicketModel["end_date"] = null;
      this.endDate = null;
    }

    this.searchControl.setValue(ticket.location.address);
    //console.log(this.editTicketModel);
    //this.updateTicketModalAdmin.open();
  }

  public validateForm(): boolean {
    let valid: boolean = true;

    valid = this.validateLocation() ? valid : false;
    valid = this.validatePrice() ? valid : false;
    //valid = this.validateNoOfTickets() ? valid : false;

    // if (this.editTicketModel.is_free) {
    // } else {
    //   delete this.editErrors['price_per_ticket'];
    // }
    // if (this.editTicketModel.unlimited_tickets) {
    // } else {
    //   delete this.editErrors['number_of_tickets'];
    // }
    return valid;
  }

  public isPrice(num) {
    let re = /^\d{0,8}(\.\d{1,2})?$/;
    return new RegExp(re).test(num);
  }

  public validatePrice(): boolean {
    if (
      this.editTicketModel.is_free ||
      (this.isPrice(parseFloat(this.editTicketModel.price_per_ticket)) &&
        this.editTicketModel.price_per_ticket !== undefined &&
        this.editTicketModel.price_per_ticket !== null &&
        parseInt(this.editTicketModel.price_per_ticket) > 0)
    ) {
      delete this.editErrors["price_per_ticket"];
      return true;
    } else {
      this.editErrors["price_per_ticket"] =
        "Price should be max 8 digits before decimal and 2 digits after decimal";
      return false;
    }
  }

  public validateLocation(): boolean {
    if (this.searchControl.value.length > 0) {
      delete this.editErrors["location"];
      return true;
    } else {
      this.editErrors["location"] = "Location is required";
      return false;
    }
  }

  public validatePickUpAddress(): boolean {
    if (this.ticket.pick_up_address && this.ticket.pick_up_address.length > 0) {
      delete this.editErrors["pick_up_address"];
      this.checkOtherErrors();
      return true;
    } else {
      this.editErrors["pick_up_address"] = "This field is required";
      return false;
    }
  }

  public validateNoOfTickets(): boolean {
    if (
      this.editTicketModel.unlimited_tickets ||
      (this.editTicketModel.number_of_tickets !== null &&
        parseInt(this.editTicketModel.number_of_tickets) > 0)
    ) {
      delete this.editErrors["number_of_tickets"];
      return true;
    } else {
      this.editErrors["number_of_tickets"] =
        "No of tickets should be greater than 0";
      return false;
    }
  }

  public updateAdminTicket(): void {
    //console.log(this.editTicketModel, this.searchControl.value);

    if (!this.validateForm()) {
      // Validation failed
      //console.log(this.editErrors);
      return;
    }
    let url = constants.URLs.createNewTicket.replace(
      "{user_id}",
      localStorage.getItem("userId")
    );
    url = url + this.editTicketModel["ticket_id"] + "/";
    //console.debug(url);
    let model = {};

    if (this.editTicketModel.status != 0) {
      model = {
        price_per_ticket: parseFloat(this.editTicketModel["price_per_ticket"]),
        description: this.editTicketModel["description"],
        category: this.editTicketModel["category"],
        event_date: this.editTicketModel["event_date"],
        end_date: this.editTicketModel["end_date"],
        location: this.editTicketModel["location"],
        is_free: this.editTicketModel["is_free"],
        pick_up_address: this.editTicketModel["pick_up_address"],
        title: this.editTicketModel["title"],
        number_of_tickets: this.editTicketModel["number_of_tickets"],
      };
    } else {
      model = {
        price_per_ticket: parseFloat(this.editTicketModel["price_per_ticket"]),
        description: this.editTicketModel["description"],
        category: this.editTicketModel["category"],
        event_date: this.editTicketModel["event_date"],
        end_date: this.editTicketModel["end_date"],
        location: this.editTicketModel["location"],
        is_free: this.editTicketModel["is_free"],
        pick_up_address: this.editTicketModel["pick_up_address"],
        title: this.editTicketModel["title"],
      };
    }

    if (this.editImage) {
      model["image"] = this.editImage;
    }
    this.showLoader = true;

    this.adminService
      .myPutCall(url, model, true)
      .then((res) => {
        //console.log('Update Ticket res');
        //console.log(res);
        document.getElementById("edit-close-confirm").click();
        this.showLoader = false;
        this.adminService.showSuccessToast(constants.messages.ticketUpdate);
        // let ticket = this.tickets.filter((tkt) => tkt.ticket_id === this.ticket.ticket_id)[0];
        // ticket.category = this.categories.filter((cat) => cat.category_id == this.ticket.category_id)[0];
        // this.updateTicketModalAdmin.close();
        this.getTickets();
        this.editForm.control.markAsPristine();
      })
      .catch((error: any) => {
        this.showLoader = false;
        try {
          //console.log('TicketComponent- Invalid user input', error);
          let errorRes: ErrorResponse = error.json();
          // Use in opertor to check if key the exists in an object
          this.adminService.showErrorToast(errorRes.error_msg);
        } catch (e) {
          //console.log('TicketComponent- an error occurred', error);
          this.adminService.showErrorToast(error);
        }
      });
  }

  public updateTicket(): void {
    //console.debug('Update Ticket');
    //console.log(this.ticket);
    this.validateEndDate();
    let url = constants.URLs.updateTicket.replace(
      "{ticket_id}",
      this.ticket.ticket_id
    );
    //console.debug(url);
    let model = {
      category: +this.ticket.category_id,
    };
    this.showLoader = true;
    this.adminService
      .putCall(url, model, true)
      .then((res) => {
        //console.log('Update Ticket res');
        //console.log(res);
        this.showLoader = false;
        this.adminService.showSuccessToast(constants.messages.ticketUpdate);
        let ticket = this.tickets.filter(
          (tkt) => tkt.ticket_id === this.ticket.ticket_id
        )[0];
        ticket.category = this.categories.filter(
          (cat) => cat.category_id == this.ticket.category_id
        )[0];
        this.closeUpdateTicketModal();
        this.getTickets();
      })
      .catch((error: any) => {
        this.showLoader = false;
        try {
          this.errorMsg =
            error.json().error_msg || constants.messages.serverError;
          //console.debug('TicketComponent- an error occurred', error);
        } catch (e) {
          this.errorMsg = error.message
            ? error.message
            : constants.messages.serverError;
          //console.error('TicketComponent- an error occurred', error);
        }
        this.adminService.showErrorToast(this.errorMsg);
      });
  }

  public clearNoOfTickets() {
    if (this.editTicketModel["unlimited_tickets"]) {
      this.editTicketModel["number_of_tickets"] = null;
    }
  }

  public clearPriceTicket() {
    if (this.editTicketModel["is_free"]) {
      this.editTicketModel["price_per_ticket"] = 0;
    }
  }

  public formatDate(date) {
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) {
      month = "0" + month;
    }
    if (day.length < 2) {
      day = "0" + day;
    }

    return [year, month, day].join("-");
  }

  public isDigit(event): boolean {
    return UtilService.isDigit(event);
  }

  public isNumber(event): boolean {
    return UtilService.isNumber(event);
  }

  public openCloneModal(ticket) {
    // console.log(ticket);
    this.clonableTicket = { ...ticket };
    this.cloneModel = {};
    this.cloneModel.title = ticket["title"];
    this.cloneModel.company_name = ticket["company_name"];
    this.cloneModel.is_recurrence_ticket = ticket["is_recurrence_ticket"];

    this.cloneModel.image = "";
    this.imageUpload_Id = "";
    this.clonableTicket["imageUploadId"] = "";
    this.imageError = false;
    this.cloneModel.purchase_before_date = ticket["purchase_before_date"];

    if (ticket["is_recurrence_ticket"] === true) {
      if (new Date(ticket["recurrence_start_date"]) >= this.minEventDate) {
        this.cloneModel.recurrence_start_date = new Date(
          ticket["recurrence_start_date"]
        );
      } else {
        this.cloneModel.recurrence_start_date = new Date();
        this.cloneModel.recurrence_start_date.setDate(
          this.minEventDate.getDate() + 1
        );
      }

      if (ticket["recurrence_end_date"]) {
        const testDate = new Date();
        testDate.setDate(testDate.getDate() + 1);
        if (new Date(ticket["recurrence_end_date"]) >= testDate) {
          this.cloneModel.recurrence_end_date = new Date(
            ticket["recurrence_end_date"]
          );
        } else {
          this.cloneModel.recurrence_end_date = new Date();
          this.cloneModel.recurrence_end_date.setDate(
            this.minEventDate.getDate() + 1
          );
        }
      }
    } else {
      if (new Date(ticket["event_date"]) > this.minEventDate) {
        this.cloneModel.event_date = new Date(ticket["event_date"]);
      } else {
        this.cloneModel.event_date = new Date();
        this.cloneModel.event_date.setDate(this.minEventDate.getDate() + 1);
      }

      if (ticket["end_date"]) {
        const testDate = new Date();
        testDate.setDate(testDate.getDate() + 1);
        if (new Date(ticket["end_date"]) > testDate) {
          this.cloneModel.end_date = new Date(ticket["end_date"]);
        } else {
          this.cloneModel.end_date = new Date();
          this.cloneModel.end_date.setDate(this.minEventDate.getDate() + 2);
        }
      }
    }
    // console.log(this.cloneModel);
    this.cloneTicketModal.open();
  }

  public cloneTicket(ticket) {
    const body: any = {};
    this.imageError = false;
    if (ticket["location"]) {
      body["location"] = ticket["location"];
    }
    if (ticket["imageUploadId"]) {
      body["image"] = ticket["imageUploadId"];
    }
    // else if (ticket["image"]) {
    //   body["image"] = ticket["image"].image_id;
    // }
    else {
      this.imageError = true;
      return;
    }
    if (ticket["city"]) {
      body["city"] = ticket["city"];
    }
    if (ticket["number_of_tickets"]) {
      body["number_of_tickets"] = ticket["number_of_tickets"];
    }
    if (ticket.hasOwnProperty("is_free")) {
      body["is_free"] = ticket["is_free"];
    }
    if (ticket["pick_up_address"]) {
      body["pick_up_address"] = ticket["pick_up_address"];
    }
    if (ticket["title"]) {
      body["title"] = ticket["title"];
    }
    if (ticket["purchase_before_date"]) {
      body["purchase_before_date"] = ticket["purchase_before_date"];
    }
    if (ticket["description"]) {
      body["description"] = ticket["description"];
    }
    if (ticket["category"]) {
      body["category"] = ticket["category"].category_id;
    }
    if (ticket["price"]) {
      body["price"] = ticket["price"];
    }

    if (ticket["is_recurrence_ticket"] === true) {
      if (ticket["recurrence_start_date"]) {
        body["recurrence_start_date"] = this.formatDate(
          this.cloneModel["recurrence_start_date"]
        );
      }
      if (ticket["recurrence_start_time"]) {
        body["recurrence_start_time"] = ticket["recurrence_start_time"];
      }
      if (ticket["recurrence_end_time"]) {
        body["recurrence_end_time"] = ticket["recurrence_end_time"];
      }
      if (ticket["week_tickets"]) {
        body["week_tickets"] = ticket["week_tickets"];
      }
      if (ticket["recurrence_pattern"]) {
        body["recurrence_pattern"] = ticket["recurrence_pattern"];
      }
      if (ticket["interval"]) {
        body["interval"] = ticket["interval"];
      }
      if (ticket["month_day"]) {
        body["month_day"] = ticket["month_day"];
      }
      if (ticket["week_days"] && ticket["week_days"].length !== 0) {
        body["week_days"] = ticket["week_days"];
      }
      if (ticket["week_no"]) {
        body["week_no"] = ticket["week_no"];
      }
      if (ticket["year_month"]) {
        body["year_month"] = ticket["year_month"];
      }
      if (ticket["month_week_day"]) {
        body["month_week_day"] = ticket["month_week_day"];
      }

      if (ticket["recurrence_end_date"]) {
        body["recurrence_end_date"] = this.formatDate(
          this.cloneModel["recurrence_end_date"]
        );
      } else if (ticket["no_of_recurrence"]) {
        body["no_of_recurrence"] = ticket["no_of_recurrence"];
      } else {
        body["no_end_date"] = true;
      }
    } else {
      if (ticket["event_date"]) {
        body["event_date"] = this.cloneModel["event_date"];
      }
      if (ticket["end_date"]) {
        body["end_date"] = this.cloneModel["end_date"];
      }
    }

    let url = constants.URLs.createNewTicket.replace(
      "{user_id}",
      localStorage.getItem("userId")
    );

    if (ticket["is_recurrence_ticket"] === true) {
      url = url + "?is_recurrence_ticket=True";
    }
    this.showLoader = true;
    this.adminService
      .postCall(url, body, true)
      .then((res) => {
        //console.debug('saveNewTicket res');
        //console.debug(res);
        this.cloneTicketModal.close();
        this.showLoader = false;
        this.adminService.showSuccessToast("Ticket Succesfully Cloned");
        this.getTickets();
      })
      .catch((error: any) => {
        this.showLoader = false;
        try {
          //console.log('TicketComponent- Invalid user input', error);
          let errorRes: ErrorResponse = error.json();
          // Use in opertor to check if key the exists in an object
          this.adminService.showErrorToast(errorRes.error_msg);
          if ("ticket_id" in errorRes) {
            this.ticketId = errorRes["ticket_id"];
            this.confirmViewDuplicateTicketModal.open();
          }
        } catch (e) {
          //console.log('TicketComponent- an error occurred', error);
          this.adminService.showErrorToast(error);
        }
      });
  }

  public openApproveRejectModal(tkt: Ticket): void {
    this.ticket = tkt;
    // this.addDummyUsers(this.ticket.flagged_by);
    this.errorMsg = null;
    this.approveRejectModal.open();
  }

  public closeApproveRejectModal(): void {
    this.approveRejectModal.close();
    this.ticket = null;
  }

  public closeCloneModal(): void {
    this.cloneTicketModal.close();
  }

  public closeCloneApprovedModal(): void {
    this.clonableTicket.title = this.cloneModel.title;
    this.clonableTicket.purchase_before_date =
      this.cloneModel.purchase_before_date;
    this.cloneTicket(this.clonableTicket);
    // this.cloneTicketModal.close();
  }

  public approveRejectTicket(tkt: Ticket, action: string): void {
    //console.log(`approveRejectTicket, action=${action}`);
    //console.log(this.ticket);
    let flag: number;
    switch (action) {
      case "approve":
        flag = 1;
        break;
      case "reject":
        flag = 2;
        break;
      default:
        //console.error(`Invalid action ${action}`);
        return;
    }
    let url = constants.URLs.approveRejectFakeTicketRequest.replace(
      "{ticket_id}",
      this.ticket.ticket_id
    );
    //console.debug(url);
    let model = {
      flag: flag,
    };
    this.showLoader = true;
    this.adminService
      .approveRejectTicket(url, model, true)
      .then((res) => {
        //console.log('Approve Reject Ticket res');
        //console.log(res);
        this.showLoader = false;
        this.closeApproveRejectModal();
        let msg =
          flag === 1
            ? constants.messages.fakeTicketRequestApproved
            : constants.messages.fakeTicketRequestRejected;
        this.adminService.showSuccessToast(msg);
        this.getTickets();
      })
      .catch((error: any) => {
        this.showLoader = false;
        try {
          this.errorMsg =
            error.json().error_msg || constants.messages.serverError;
          //console.debug('approveRejectTicket- an error occurred', error);
        } catch (e) {
          this.errorMsg = error.message
            ? error.message
            : constants.messages.serverError;
          //console.error('approveRejectTicket- an error occurred', error);
        }
      });
  }

  public getColspan(): number {
    let colspan;
    switch (this.ticketType) {
      case 2:
        colspan = 15;
        break;
      default:
        colspan = 15;
    }
    return colspan;
  }

  private addDummyUsers(users: any): User[] {
    users.push({
      name: "User 1",
      email: "user1@gmail.com",
      phone_number: "123",
    });
    users.push({
      name: "User 2",
      email: "user2@gmail.com",
      phone_number: "123",
    });
    users.push({
      name: "User 3",
      email: "user3@gmail.com",
      phone_number: "123",
    });
    users.push({
      name: "User 4",
      email: "user4@gmail.com",
      phone_number: "123",
    });
    users.push({
      name: "User 5",
      email: "user5@gmail.com",
      phone_number: "123",
    });
    users.push({
      name: "User 6",
      email: "user6@gmail.com",
      phone_number: "123",
    });
    users.push({
      name: "User 7",
      email: "user7@gmail.com",
      phone_number: "123",
    });
    return users;
  }

  public appendFormImage(event, type: any): void {
    //console.log(event);
    if (event.target.files && event.target.files[0]) {
      // Validate selected image dimension and Preview picture
      let reader = new FileReader();
      reader.onload = (e: any) => {
        // this.ticket.previewImageUrl = e.target.result;

        this.uploadTicketImage(event.target.files[0], type); // TODO UNCOMMENT ME
      };
      reader.readAsDataURL(event.target.files[0]);
      this.disabled = false;
      this.imageError = false;
    } else {
      this.ticket.previewImageUrl = null;
      this.ticket.image = null;
      // this.disabled=true;
    }
  }

  public uploadTicketImage(file: any, type: any): void {
    this.cntErrorMsg = null;
    let url = constants.URLs.uploadTicketImage;
    let form = new FormData();
    form.append("image[file]", file);
    let x = "";
    this.disabled = true;
    let that = this;
    this.adminService
      .uploadImages(url, form)
      .then((res) => {
        // console.debug('uploadTicketImage res');
        // console.debug(res);
        that.disabled = false;
        x = res.image_id;
        this.getImageUrl(x, type);
        // this.validateTicketImage();
        // this.adminService.showSuccessToast(constants.messages.uploadTicketImage);
      })
      .catch((error: any) => {
        try {
          //console.debug('TicketComponent- Invalid user input', error);
          this.cntErrorMsg =
            error.json().error_msg || constants.messages.serverError;
        } catch (e) {
          //console.error('TicketComponent- an error occurred', error);
          this.cntErrorMsg = error.message
            ? error.message
            : constants.messages.serverError;
        }
        // this.clonableTicket['imageUploadId'] = this.imageUpload_Id;
        this.adminService.showErrorToast(this.cntErrorMsg);
      });
  }

  getImageUrl(x, type: any) {
    if (type == "clone") {
      this.clonableTicket["imageUploadId"] = x;
    } else if (type == "edit") {
      this.editImage = x;
    }
  }

  // public validateTicketImage(): boolean {
  //   if (this.ticket.image && this.ticket.image.image_id) {
  //     delete this.formErrors['image'];
  //     this.checkOtherErrors();
  //     return true;
  //   } else {
  //     this.formErrors['image'] = 'This field is required';
  //     return false;
  //   }
  // }

  public checkOtherErrors(): void {
    if (Object.keys(this.formErrors).length === 0) {
      // There are no other errors
      this.cntErrorMsg = null;
    }
  }

  public validateEventDate(): boolean {
    if (this.ticket.event_date) {
      delete this.formErrors["event_date"];
      this.checkOtherErrors();
      return true;
    } else {
      this.formErrors["event_date"] = "This field is required";
      return false;
    }
  }

  changeNoOfDays(e: any) {
    if (e.target.checked) {
      this.eventDays = true;
      this.editTicketModel["end_date"] = this.endDate;
    } else {
      this.eventDays = false;
      this.editTicketModel["end_date"] = null;
    }
  }

  public validateEndDate(): boolean {
    if (this.ticket.end_date) {
      delete this.formErrors["end_date"];
      this.checkOtherErrors();
      return true;
    } else {
      this.formErrors["end_date"] = "This field is required";
      return false;
    }
  }

  public deleteTicket(ticket: Ticket): void {
    let url = constants.URLs.deleteTicket.replace(
      "{user_id}",
      localStorage.getItem("userId")
    );
    url = url.replace("{ticket_id}", ticket.ticket_id);

    this.disableDelete = true;
    this.adminService
      .cancelTicket(url, true)
      .then((res) => {
        this.closeDeleteTicketModal();
        if (res.status === "success") {
          this.adminService.showSuccessToast(constants.messages.deleteTicket);
          this.getTickets();
        }
        this.disableDelete = false;
      })
      .catch((error: any) => {
        ticket.isCancelled = !ticket.isCancelled; // Revert the change
        try {
          this.errorMsg =
            error.json().error_msg || constants.messages.serverError;
        } catch (e) {
          this.errorMsg = error.message
            ? error.message
            : constants.messages.serverError;
        }
        this.disableDelete = false;
        this.closeDeleteTicketModal();
        this.adminService.showErrorToast(this.errorMsg);
      });
  }

  deleteUpdateTicketErrors() {
    delete this.editErrors["price_per_ticket"];
    delete this.editErrors["number_of_tickets"];
    delete this.editErrors["location"];
    delete this.editErrors["pick_up_address"];
  }

  public viewDuplicateTicketModal(ticketId): void {
    this.confirmViewDuplicateTicketModal.close();
    // document.getElementById("detailsModalClick").click();
    window.open(
      constants.serverUrl +
        "/manage/tickets?tkttype=" +
        this.ticketType +
        "&tktid=" +
        ticketId,
      "_blank"
    );
  }

  getTicketDetail(ticketId) {
    let url = constants.URLs.getTicket.replace("{ticket_id}", ticketId);

    this.adminService
      .getCall(url, true)
      .then((ticket) => {
        // if (res.status === "success") {
        // this.editTicketModel = res;
        this.editTicketModel["image"] = null;
        this.deleteUpdateTicketErrors();
        this.eventDays = ticket.end_date ? true : false;
        this.editTicketModel["ticket_id"] = ticket.ticket_id;
        this.editTicketModel["price_per_ticket"] = ticket.price.per_ticket || 0;
        this.editTicketModel["description"] = ticket.description;
        this.editTicketModel["category"] = ticket.category.category_id || 1;
        this.editTicketModel["event_date"] = ticket.event_date;
        this.editTicketModel["number_of_tickets"] = ticket.number_of_tickets;
        this.editTicketModel["unlimited_tickets"] =
          ticket.number_of_tickets === null;
        this.editTicketModel["location"] = ticket.location;
        this.editTicketModel["is_free"] = ticket.is_free;
        this.editTicketModel["is_recurring"] = ticket.is_recurrence_ticket
          ? "Yes"
          : "No";
        this.editTicketModel["image"] = null;
        this.editTicketModel["eventMoreThanOneDay"] = this.eventDays;
        this.editTicketModel["pick_up_address"] = ticket.pick_up_address;
        this.editTicketModel["title"] = ticket.title;
        this.editTicketModel["purchase_ticket_count"] =
          ticket.purchase_ticket_count ? ticket.purchase_ticket_count : 0;
        this.editTicketModel["creator"] =
          ticket.seller && ticket.seller.name ? ticket.seller.name : "";
        this.editTicketModel["status"] = ticket.status;
        this.categoryName = ticket.category.name;
        if (this.eventDays) {
          this.editTicketModel["end_date"] = ticket.end_date
            ? ticket.end_date
            : null;
          this.endDate = ticket.end_date;
        } else {
          this.editTicketModel["end_date"] = null;
          this.endDate = null;
        }

        if (this.editTicketModel["status"] == 1) {
          this.searchControl.setValue(ticket.location.address);
        }
        document.getElementById("editModalClick").click();
        var elem = document.getElementsByClassName("modal-backdrop");

        for (let i = 0; i < elem.length; i++) {
          elem[i].remove();
        }
        // }
      })
      .catch((error: any) => {
        try {
          this.errorMsg =
            error.json().error_msg || constants.messages.serverError;
        } catch (e) {
          this.errorMsg = error.message
            ? error.message
            : constants.messages.serverError;
        }
        this.adminService.showErrorToast(this.errorMsg);
      });
  }

  confirmEditClose(isDirty) {
    if (isDirty) {
      this.confirmEditCloseModal.open();
    } else {
      document.getElementById("edit-close-confirm").click();
    }
  }

  confirmEditCloseConfirmed() {
    this.editForm.control.markAsPristine();
    this.confirmEditCloseModal.close();
    document.getElementById("edit-close-confirm").click();
  }

  onTicketSourceChange(source) {
    this.ticketSourceValue = source;
    this.ticketSource = source;
    this.getTickets(this.page);
  }

  getCompanyName(ticket) {
    return ticket.seller &&
      ticket.seller.name == "Admin" &&
      !ticket.is_recurrence_ticket
      ? "One Time Ticket"
      : ticket.seller &&
        ticket.seller.name == "Admin" &&
        ticket.is_recurrence_ticket
      ? "Recurring Ticket"
      : ticket.company_name
      ? ticket.company_name
      : "";
  }

  getReasons(reasons) {
    return reasons.slice(Math.max(reasons.length - 2, 0));
  }
}



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-3!./~/angular2-template-loader!./src/app/manage/ticket/ticket.component.ts